<template>
  <div class="container-custom">
    <!-- Breadcrumbs -->
    <Breadscrumbs
      :links="[
        {
          name: 'Where To Buy',
          to: {
            name: 'WhereToBuy'
          }
        },
        {
          name: 'Create',
          to: {
            name: 'WhereToBuyCreate'
          }
        }
      ]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>新增 Where To Buy</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>
    <!--  -->
    <WhereToBuyCreateEdit></WhereToBuyCreateEdit>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import WhereToBuyCreateEdit from '@/views/H_WhereToBuy/c/WhereToBuyCreateEdit.vue';

export default {
  components: {
    Breadscrumbs,
    WhereToBuyCreateEdit,
  },
  computed: {
    ...mapState(['currentBuTabId']),
    ...mapState('buyChannel', ['buyChannel']),
  },
  created() {
    this.setBuyChannel({
      type: 1,
      bu_id: this.currentBuTabId,
      categories: [],
    });
  },
  methods: {
    ...mapActions('buyChannel', ['setBuyChannel', 'save']),
    cancelHandler() {
      this.$router.push({ name: 'WhereToBuy' });
    },
    saveHandler() {
      this.save(this.buyChannel).then(() => {
        this.$router.push({ name: 'WhereToBuy' });
      });
    },
  },
};
</script>

<style></style>
